import type { NskResponse } from "~/models/Api";
import { putRequest } from "~/utils/api/api_handler";
import { generatePath } from "~/utils/generatePath";

export const update = async (
	dealId: number,
	expectedAccountingDate: string | null
): Promise<NskResponse> =>
	putRequest(
		generatePath("/deals/:deal_id/deal_expected_accounting_date", {
			deal_id: dealId
		}),
		{ expectedAccountingDate }
	);
